module.exports = __webpack_public_path__ + "img/slide-32.c663f50f.jpg";